'use client';

import { FilterX, PackageSearch } from 'lucide-react';
import Link from 'next/link';
import { useTranslations } from 'next-intl';

interface CatalogEmptyStateProps {
  /** True when client-side or URL filters are active — shows reset CTA */
  hasFilters: boolean;
  onReset: () => void;
  /** Label for the item type, e.g. "kursus" or "latihan soal" */
  itemLabel: string;
  /** "Lihat semua" link when filters are active, e.g. "/courses" */
  allHref: string;
}

export function CatalogEmptyState({ hasFilters, onReset, itemLabel, allHref }: CatalogEmptyStateProps) {
  const t = useTranslations('catalog');
  if (hasFilters) {
    return (
      <div className="flex flex-col items-center justify-center py-20 text-center px-4">
        <div className="w-16 h-16 rounded-2xl bg-slate-100 flex items-center justify-center mb-4">
          <FilterX className="w-8 h-8 text-slate-400" />
        </div>
        <p className="font-semibold text-slate-800 text-base mb-1">
          {t('emptyNoMatchTitle')}
        </p>
        <p className="text-slate-500 text-sm mb-5 max-w-xs">
          {t('emptyNoMatchDesc', { itemLabel })}
        </p>
        <div className="flex items-center gap-3">
          <button
            onClick={onReset}
            className="px-4 py-2 rounded-lg text-sm font-semibold bg-teal-600 text-white hover:bg-teal-700 transition-colors"
          >
            {t('emptyResetFilters')}
          </button>
          <Link
            href={allHref}
            className="px-4 py-2 rounded-lg text-sm font-medium text-slate-600 bg-white border border-slate-200 hover:border-slate-300 transition-colors"
          >
            {t('emptySeeAll')}
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center py-20 text-center px-4">
      <div className="w-16 h-16 rounded-2xl bg-slate-100 flex items-center justify-center mb-4">
        <PackageSearch className="w-8 h-8 text-slate-400" />
      </div>
      <p className="font-semibold text-slate-800 text-base mb-1">
        {t('emptyNoneTitle', { itemLabel })}
      </p>
      <p className="text-slate-500 text-sm max-w-xs">
        {t('emptyNoneDesc')}
      </p>
    </div>
  );
}
